import { inject, Service } from "@angular/core";

import { MainResponseModel, ProjectCycle } from "../models";
import { MainService } from "./main-service";

@Service()
export class TpCyclesApiService {
  private _mainService = inject(MainService);

  public getAllCycles() {
    const url = `national-project-cycle/getall`;

    return this._mainService.sendRequest<MainResponseModel<ProjectCycle[]>>({
      method: "POST",
      url,
      data: {},
    });
  }

  public getTPCycleById(tpCycleId: number) {
    const url = `national-project-cycle/getbyid/${tpCycleId}`;

    return this._mainService.sendRequest<MainResponseModel<ProjectCycle>>({
      method: "GET",
      url,
    });
  }

  public saveCycle(isUpdate: boolean, cycle: Partial<ProjectCycle>) {
    const url = isUpdate ? `national-project-cycle/update` : `national-project-cycle/create`;

    return this._mainService.sendRequest<MainResponseModel<number>>({
      method: "POST",
      url,
      data: cycle,
    });
  }

  public deleteTPCycle(tpCycleId: number) {
    const url = `national-project-cycle/delete/${tpCycleId}`;

    return this._mainService.sendRequest<MainResponseModel<number>>({
      method: "DELETE",
      url,
    });
  }
}
